import $ from 'jquery'
import Base from 'luminate/src/modules/base'

export default Base.extend({
	directive: 'category-select',

	events: {
		init: function() {
			$(this.$element).change(function(e) {
				window.location.href = `${window.location.origin}/${$(this).find('select').val()}`
			})
		}
	}
})



// WEBPACK FOOTER //
// ./source/scripts/legacy/modules/category-select.js